import { render } from "./AlliedPartyAgenda.vue?vue&type=template&id=319a6f53&ts=true"
import script from "./AlliedPartyAgenda.vue?vue&type=script&lang=ts"
export * from "./AlliedPartyAgenda.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__